import styled from "styled-components";
import { colors, typography } from "../../assets/styles/GlobalStyles";

export const PrimaryButton = styled.a`
    font-family: ${typography.global.fontFamilyCopy};
    color: black;
    background: ${colors.white};
    border-radius: 50px;
`